import { render, staticRenderFns } from "./set-password.vue?vue&type=template&id=706def83&"
import script from "./set-password.vue?vue&type=script&lang=js&"
export * from "./set-password.vue?vue&type=script&lang=js&"
import style0 from "./set-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706def83')) {
      api.createRecord('706def83', component.options)
    } else {
      api.reload('706def83', component.options)
    }
    module.hot.accept("./set-password.vue?vue&type=template&id=706def83&", function () {
      api.rerender('706def83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/set-password.vue"
export default component.exports